import HyperDX from '@hyperdx/browser';
import * as Sentry from '@sentry/react';

const dsn =
  import.meta.env.VITE_GLITCHTIP_DSN ||
  'https://27dc9efffe9d4508b51e6237200e7cab@bsr-log.boonsiri.co.th/10';

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.01,
    autoSessionTracking: false,
  });
}

const hyperdxKey = import.meta.env.VITE_HYPERDX_API_KEY;
if (import.meta.env.PROD && hyperdxKey) {
  const otelUrl = (
    import.meta.env.VITE_OTEL_EXPORTER_OTLP_ENDPOINT ||
    'https://bsr-otel.boonsiri.co.th'
  ).replace(/\/$/, '');
  HyperDX.init({
    apiKey: hyperdxKey,
    service: import.meta.env.VITE_OTEL_SERVICE_NAME || 'hr-frontend',
    url: otelUrl,
    tracePropagationTargets: [/api-hr\.boonsiri\.co\.th/i],
    maskAllInputs: true,
    // keep replay on; throttle rrweb + skip canvas/body capture to ease bsr-otel
    advancedNetworkCapture: false,
    recordCanvas: false,
    ignoreUrls: [/bsr-otel\.boonsiri\.co\.th/i],
    sampling: {
      mousemove: 150,
      mouseInteraction: 800,
      scroll: 300,
      media: 1000,
      input: 'last',
    },
  });
}

export { Sentry };
